export default defineNuxtRouteMiddleware((to, _from) => {
    if (to.path.startsWith("/dashboard")) {
        const { isAuthenticated } = useSanctumAuth();
        if (!isAuthenticated.value) {
            return navigateTo("/auth/login");
        }
    }
    if (to.path.startsWith("/auth")) {
        const { isAuthenticated } = useSanctumAuth();
        if (isAuthenticated.value) {
            return navigateTo("/dashboard");
        }
    }
});
